import { render, staticRenderFns } from "./Visit.vue?vue&type=template&id=0f4f7866&scoped=true&"
import script from "./Visit.vue?vue&type=script&lang=js&"
export * from "./Visit.vue?vue&type=script&lang=js&"
import style0 from "./Visit.vue?vue&type=style&index=0&id=0f4f7866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f7866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFlex,VLayout,VRow})
